import React from "react";
import axios from "axios";
import {Image} from "react-img-placeholder";
import Dialog from "@material-ui/core/Dialog";
import CardActionArea from "@material-ui/core/CardActionArea";

export class ImageLoader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imageData: "xxx",
            isOpen:false,
            imageThumbnail: 'data:image/png;base64,'+this.props.thumbnail,
        }
    }

    handleShowDialog = (id) => {
        this.setState({isOpen:true});
        console.log("cliked");
    };


    handleHideDialog = () => {
        this.setState({isOpen:false});
        console.log("closed");
    };

    componentDidMount(){
        console.log(this.props.url,this.props.thumbnail)
        this.loadImage(this.props.url)
    }

    async loadImage(url) {
        // const headers = new Headers();
        // headers.set('Authorization', 'Bearer ' + localStorage.getItem("pwa_messenger_token"));
        // let response = await fetch(url, {headers})
        // let d = Buffer.from(pic.data).toString('base64');

        try {
            let response = await axios.get(url, {
                headers: {Authorization: 'Bearer ' + localStorage.getItem("pwa_messenger_token")},
                responseType: "arraybuffer",
            })
            let data = `data:${
                response.headers["content-type"]
            };base64,${new Buffer(response.data, "binary").toString("base64")}`;
            this.setState({imageData:data})
        } catch (error) {
            console.log(error)
        }


    }

    render() {
        const handleClose = () => {
            console.log("dasdsadas")
        };

        return (
            <div>
                <Image
                    key={this.props.url}
                    src={this.state.imageData}
                    height={'100%'}
                    width={'100%'}
                    alt="big size logo"
                    onClick={this.handleShowDialog}
                    placeholderSrc={this.state.imageThumbnail}
                />
                <Dialog

                    open={this.state.isOpen}
                >
                    <img
                        width={16}
                        height={16}
                        style={{margin:8}}
                        onClick={this.handleHideDialog}
                    src='https://cdn-icons-png.flaticon.com/512/61/61155.png?w=740&t=st=1677848211~exp=1677848811~hmac=2bf2b3bfd35b806a4396d3c9bae4f1a690f3d0f5929b28e170818ec4cc3b080c'/>
                    <Image
                        key={this.props.url}
                        src={this.state.imageData}
                        height={this.props.height/1.8}
                        width={this.props.width/1.8}
                        alt="big size logo"
                        placeholderSrc={this.state.imageThumbnail}
                    />
                </Dialog>
            </div>

            );
    }

}
